import { create } from "zustand";
import {
  createWorkflowRunCoreSlice,
  workflowRunCoreInitialState,
  type WorkflowRunCore,
} from "src/views/products/workflow/store/createWorkflowRunStore";

type ExtrasState = {
  selectedPlantId: number | null;
  activityTitle: string;
  activityDescription: string;
};

type ExtrasAction = {
  setSelectedPlantId: (id: number | null) => void;
  setActivityTitle: (title: string) => void;
  setActivityDescription: (description: string) => void;
  reset: () => void;
};

const extrasInitialState: ExtrasState = {
  selectedPlantId: null,
  activityTitle: "",
  activityDescription: "",
};

export const useFfnStore = create<WorkflowRunCore & ExtrasState & ExtrasAction>()(
  (set, get) => ({
    ...createWorkflowRunCoreSlice(set, get),
    ...extrasInitialState,
    setSelectedPlantId: (id) => set({ selectedPlantId: id }),
    setActivityTitle: (title) => set({ activityTitle: title }),
    setActivityDescription: (description) =>
      set({ activityDescription: description }),
    reset: () =>
      set((state) => ({
        ...workflowRunCoreInitialState,
        ...extrasInitialState,
        // See createWorkflowRunCoreSlice: the uploader's registered function
        // must survive data resets.
        removeUploadedFile: state.removeUploadedFile,
      })),
  }),
);
